import { Html } from "@react-three/drei";

const Intro = (props) => {

  return (
    <>
      <Html
        className="page"
        {...props}
        fullscreen
        zIndexRange={[0, 0]}
        onClick={() => console.log("click")}
        visible={props.visible}
      >
        {props.visible ? (
          <>
            <img src="./logo.svg" className="logo" alt="cybertruck-logo" />
            <span className="tagline">
              BETTER UTILITY THAN A TRUCK WITH MORE PERFORMANCE THAN A SPORTS
              CAR
            </span>
          </>
        ) : null}
      </Html>
    </>
  );
};

export default Intro;
